/**
 * Public property + i18n in the browser.
 *
 * - **Dev (default):** live API via Vite `/v1` proxy — no `i18n:export` / image sync on every restart.
 * - **Dev (bundled):** set `VITE_DEV_USE_BUNDLED_CMS=true` to use committed `generated/*.json` only.
 * - **Production:** API when export fingerprints differ; SSG HTML still embeds published snapshots at build time.
 */
export function shouldSyncPublicCmsFromApi() {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_DEV_USE_BUNDLED_CMS !== 'true';
  }
  return true;
}
